<template>
  <div class="Footer">
    <h1>Kies een onderdeel op het stadsgezicht uit 1644 om verder te gaan</h1>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
.Footer {
  color: var(--wit);
  background-color: var(--bruin);
  display: inline-flex;
}

h1 {
  margin: auto;
  font-size:em;
  padding:0 2em;
}
</style>